import React, { useLayoutEffect, useEffect, useState } from 'react';

import isMobile from '~/utils/is-mobile';

import BG from '~/components/background';

import main_video from './images/main_video.mp4';
import main_text from './images/main_text.png';

import mid from './images/mid.png';

import mid_video from './images/mid_video.mp4';
import mid_text from './images/mid_text.png';

import bottom from './images/bottom.png';

import outter from './images/outter.png';
import inner_01 from './images/inner_01.png';
import inner_02 from './images/inner_02.png';
import complex_01 from './images/complex_01.png';
import complex_02 from './images/complex_02.png';

import footer from './images/footer.png';

import answer_btn from './images/answer_btn.png';

import camera from './images/camera.png';

import { Wrap, VideoWrap, Overlay, Modal, BGWrap, Chip } from './styled';

function clickInquiry() {
  if (isMobile.Android()) return window.location.href = 'market://details?id=kr.co.station3.dabang';
  if (isMobile.IOS()) return window.location.href = 'https://itunes.apple.com/kr/app/id814840066';
}

function IntroduceMobieView() {
  const [spaceBottom, setSpaceBottom] = useState(0);
  const [modalType, setModalType] = useState('');

  useLayoutEffect(() => {
    if (!isMobile.any()) return window.location.replace('/2022/12/introduce/');
  }, []);

  useEffect(() => {
    if (modalType) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'scroll';
    }
  }, [modalType]);

  useEffect(() => {
    const sticky = document.getElementsByClassName('sticky-btn');
    setSpaceBottom(sticky[0].getBoundingClientRect().height);
    console.log(sticky[0].getBoundingClientRect().height)
  }, []);

  return (
    <Wrap spaceBottom={spaceBottom}>
      <VideoWrap width={750} height={808}>
        <video autoPlay muted loop playsInline width="100%" height="100%">
          <source src={main_video} type="video/mp4" />
        </video>

        <img src={main_text} />
      </VideoWrap>

      <BGWrap width={750} height={3452} imgUrl={mid}>
        <button className="scroll-outter" onClick={() => window.location.href="#outter-wrap"} />
        <button className="scroll-inner" onClick={() => window.location.href="#inner-wrap"} />
        <button className="scroll-complex" onClick={() => window.location.href="#complex-wrap"} />

        <div id="outter-wrap" className="outter-wrap" />
        <div id="inner-wrap" className="inner-wrap" />
        <div id="complex-wrap" className="complex-wrap" />

        <button className="outter" onClick={() => setModalType('outter')} />
        <button className="inner" onClick={() => setModalType('inner')} />
        <button className="complex" onClick={() => setModalType('complex')} />
      </BGWrap>

      <VideoWrap width={750} height={644}>
        <video autoPlay muted loop playsInline width="100%" height="100%">
          <source src={mid_video} type="video/mp4" />
        </video>

        <img src={mid_text} />
      </VideoWrap>

      <BG width={750} height={1046} imgUrl={bottom} />

      <BG width={750} height={228} imgUrl={footer} />

      {modalType && (
        <Overlay>
          <Modal>
            <div className="box">
              {modalType === 'outter' ? (
                <>
                  <h2>
                    <img src={camera} alt="카메라" /> 외부투어
                  </h2>

                  <Chip style={{ margin: '12px 0 16px' }}>조감도</Chip>
                  <div style={{ width: '100%', marginTop: 'auto' }}>
                    <img id="a4" src={outter} style={{ cursor:'pointer', width: '100%' }} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a4/")} />
                  </div>
                </>
              ) : modalType === 'inner' ? (
                <>
                  <h2 style={{ marginBottom: '12px' }}>
                    <img src={camera} alt="카메라" /> 내부투어
                  </h2>

                  <div style={{ width: '100%', marginTop: 'auto' }}>
                    <img id="a0" src={inner_01} style={{ cursor:'pointer', width: '100%' }} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a0/")} />
                    <img id="a1" src={inner_02} style={{ marginTop: '16px', cursor:'pointer', width: '100%' }} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a1/")} />
                  </div>
                </>
              ) : modalType === 'complex' ? (
                <>
                  <h2>
                    <img src={camera} alt="카메라" /> 단지투어
                  </h2>

                  <Chip style={{ margin: '12px 0 16px' }}>커뮤니티시설</Chip>
                  <div style={{ width: '100%', marginTop: 'auto' }}>
                    <img id="a2" src={complex_01} style={{ cursor:'pointer', width: '100%' }} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a2/")} />
                  </div>

                  <Chip style={{ margin: '32px 0 16px' }}>지하주차장</Chip>
                  <div style={{ width: '100%', marginTop: 'auto' }}>
                    <img id="a3" src={complex_02} style={{ cursor:'pointer', width: '100%' }} onClick={() => window.open("http://13.209.83.132:8085/ModelHouse/a3/")} />
                  </div>
                </>
              ) : null}
            </div>

            <button onClick={() => setModalType('')}>닫기</button>
          </Modal>
        </Overlay>
      )}

      {!modalType && (
        <button className="sticky-btn" onClick={clickInquiry}>
          <BG width={750} height={112} imgUrl={answer_btn} />
        </button>
      )}
    </Wrap>
  );
}

export default IntroduceMobieView;
